import React from "react"
import PropTypes from "prop-types"
import Slider from "react-slick"
import Media from "react-media"

class Carousel extends React.Component {
  constructor(props) {
    super(props)
    const { children, className } = this.props
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      // autoplaySpeed: 5000,
      // autoplay: true,
      className,
    }
    this.mobile = <Slider {...settings}>{children}</Slider>
    this.desktop = <div className={className}>{children}</div>
    this.displayArbiter = this.displayArbiter.bind(this)
    this.state = {
      mounted: this.mobile,
    }
  }

  displayArbiter(desktop) {
    this.setState({ mounted: desktop ? this.desktop : this.mobile })
  }

  render() {
    const { mounted } = this.state
    return (
      <div>
        <Media query="(min-width: 599px)" onChange={this.displayArbiter} />
        {mounted}
      </div>
    )
  }
}

Carousel.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
}

export default Carousel
